export function BenchmarksTab() {
  return (
    <div role="tabpanel" data-testid="benchmarks">
      {/* eslint-disable-next-line i18next/no-literal-string */}
      <pre>@TODO WMG1-663 - Implement BenchmarksTab component</pre>
    </div>
  );
}

BenchmarksTab.displayName = 'BenchmarksTab';
